import { ReactNode } from "react";

type OptionCardProps = {
  icon?: ReactNode;
  title: string;
  subtitle?: string;
  selected?: boolean;
  onClick: () => void;
};

function cleanLabel(value: string) {
  if (!value) return;
  return value.replace(/^"+|"+$/g, "");
}

export function OptionCard({
  icon,
  title,
  subtitle,
  selected,
  onClick,
}: OptionCardProps) {
  const cleanTitle = cleanLabel(title);

  return (
    <button
      onClick={onClick}
      className={`
        w-full rounded-2xl border bg-white p-4 text-left shadow-sm transition
        hover:shadow-md
        ${selected ? "border-[var(--brand)] bg-[var(--brand-soft)]/40" : "border-[var(--line)]"}
      `}
    >
      <div className="flex items-center gap-3 sm:gap-4">
        {icon && (
          <div
            className={`
              flex h-11 w-11 items-center justify-center rounded-xl transition-colors
              ${
                selected
                  ? "bg-[var(--brand-soft)] text-[var(--brand)]"
                  : "bg-gray-100 text-gray-500"
              }
            `}
          >
            {icon}
          </div>
        )}

        <div className="min-w-0">
          <div className="font-semibold text-[var(--text-primary)]">{cleanTitle}</div>
          {subtitle && <div className="mt-0.5 text-sm text-[var(--text-muted)]">{subtitle}</div>}
        </div>
      </div>
    </button>
  );
}
